import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { prefetchRoute } from '@/lib/prefetch';
import { ChevronRight, Info, Briefcase, Mail } from 'lucide-react';

const ProductsHoverContainer = styled.div`
  width: 760px;
  border-radius: 12px;
  box-shadow: 5px 6px 12px 2px rgba(var(--greyr), 0.3);
  padding: 12px;
  display: flex;
  flex-direction: column;
  background-color: var(--white);

  @media (max-width: 968px) {
    width: calc(100% - 40px);
    padding: 0;
    border-radius: 0;
    box-shadow: none;
    margin-bottom: 20px;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 8px;

  @media (max-width: 968px) {
    grid-template-columns: 1fr;
    gap: 0;
  }
`;

const CardBase = styled(Link)`
  display: flex;
  position: relative;
  overflow: hidden;
  flex-direction: column;
  justify-content: space-between;
  padding: 16px;
  border-radius: 8px;
  text-decoration: none;
  cursor: pointer;
  min-height: 180px;
  transition: background-color 0.15s;
  background-color: rgba(var(--greyr), 0.08);
  background-image: repeating-linear-gradient(
    -45deg,
    transparent,
    transparent 4px,
    rgba(var(--greyr), 0.07) 4px,
    rgba(var(--greyr), 0.07) 5px
  );

  &:hover {
    background-color: rgba(var(--greyr), 0.14);
  }

  &:after {
    height: 0px !important;
    bottom: 0px !important;
  }


  @media (max-width: 968px) {
    background-color: white;
    display: flex!important;
    justify-content: flex-start;
    flex-direction: row;
    gap: 12px;
    padding-left: 10px!important;
    min-height: unset;
    background-image: none;
    border-radius: 7px;
    &:hover{
      background-color: rgba(var(--greyr), 0.1);
    }
  }
`;

const IconWrapper = styled.div`
  width: 34px;
  height: 34px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: rgba(var(--whiter), 0.85);
  background-color: rgba(var(--greyr), 0.1);
  border: 1px solid rgba(var(--greyr), 0.15);
  z-index: 2;
  flex-shrink: 0;

  svg {
    width: 16px;
    height: 16px;
    color: var(--grey);
  }

  @media (max-width: 968px) {
    width: 32px;
    height: 32px;
    margin-top: 1px;
  }
`;

const CardBottom = styled.div`
  display: flex;
  position: relative;
  z-index: 2;
  flex-direction: column;
  gap: 4px;

  @media (max-width: 968px) {
    justify-content: center;
    gap: 2px;
  }
`;

const CardTitle = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: var(--black);
  display: flex;
  align-items: center;
  gap: 3px;

  svg {
    width: 14px;
    height: 14px;
    color: var(--grey);
  }

  @media (max-width: 968px) {
    svg{
      display: none;
    }
  }
`;

const CardDescription = styled.p`
  font-size: 13px;
  color: var(--grey);
  margin: 0;
  line-height: 1.4;

  @media (max-width: 968px) {
    font-size: 12.5px;
  }
`;

const Illustration = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.1;
  filter: blur(5px);
  top: 0;
  left: 0;
  z-index: 1;

  @media (max-width: 968px) {
    display: none;
  }
`;

const ProductsHover = () => {
  return (
    <ProductsHoverContainer>
      <Grid>
        <CardBase to="/about" onMouseEnter={() => prefetchRoute('/about')}>
          <IconWrapper><Info /></IconWrapper>
          <CardBottom>
            <CardTitle>About<ChevronRight /></CardTitle>
            <CardDescription>Our story, mission, and values</CardDescription>
          </CardBottom>
          <Illustration src="/nav/1.png" alt="About AxionQuant" loading="lazy" />
        </CardBase>
        <CardBase to="/jobs" onMouseEnter={() => prefetchRoute('/jobs')}>
          <IconWrapper><Briefcase /></IconWrapper>
          <CardBottom>
            <CardTitle>Careers<ChevronRight /></CardTitle>
            <CardDescription>Open roles and life at our company</CardDescription>
          </CardBottom>
          <Illustration src="/nav/2.webp" alt="Careers at AxionQuant" loading="lazy" />
        </CardBase>
        <CardBase to="/contact" onMouseEnter={() => prefetchRoute('/contact')}>
          <IconWrapper><Mail /></IconWrapper>
          <CardBottom>
            <CardTitle>Contact<ChevronRight /></CardTitle>
            <CardDescription>Reach out and we'll get back to you</CardDescription>
          </CardBottom>
          <Illustration src="/nav/4.webp" alt="Contact AxionQuant" loading="lazy" />
        </CardBase>
      </Grid>
    </ProductsHoverContainer>
  );
};

export default ProductsHover;
